import { FetchDataProps } from "types/datacontext";
export const addDefaultFilters = (props?: FetchDataProps) => {
  const { filters, defaultFilters } = props || {};
  if (filters && defaultFilters) return filters.concat(defaultFilters);
  else if (defaultFilters) return defaultFilters;
  else return filters;
}

// Ensure that our default props override the props from LazyDataTable.
// WARNING: Do not use this for pageIndex as you will break pagination
// WARNING: Do not override filters directly. Use defaultfilters instead.
// NOTE: If you need to stay on the same page, set pagecount to 1 via the QueryFn
// instead of overriding it using the default props
export const constructProps = (props?: FetchDataProps, defaults?: Partial<FetchDataProps>): FetchDataProps => {
  const propsWithDefaults = { ...props, ...defaults };
  return {
    ...propsWithDefaults,
    filters: addDefaultFilters(propsWithDefaults)
  };
}
